module.exports = __webpack_public_path__ + "img/num03.61baa794.svg";